import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  getString(key: string): string {
    return sessionStorage.getItem(key) ?? '';
  }

  setString(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }

  getObject(key: string): any {
    const obj: any = sessionStorage.getItem(key);
    return !obj || obj === 'undefined' ? null : JSON.parse(obj);
  }

  setObject(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  clear(): void {
    sessionStorage.clear();
  }
}
